import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  StyledBoxNav,
  StyledListNav,
  StyledListTitle,
  StyledBoxList,
  StyledList,
  StyledIconDesplegated,
  StyledListLink,
  StyledListDiv,
  StyledBoxLogo,
  StyledIconClose,
  // StyledBoxScroll,
  // StyledLogoLateral,
  StyledMenu
} from './MenuListStyle';
import { Arrow, Close } from '../../../../assets/images/index';
// import LogoLateral from '../../../../assets/images/logolateral.svg';
import Logo from '../../../../assets/images/logo.svg';
import { getHeaderMenu } from '../../../utils/apiHeader';

/** HOC */
import withOutsideClick from '../Common/ClickOutside';
import SearchHeaderTop from './SearchHeaderTop';
import {
  StyledElementsRedesign,
  StyledSearchRedesign,
  StyledAccessRedesign,
  StyledMenuRedesign
} from '../../core/MenuTabs/style';
// import AppsHeader from './AppsHeader';
import { StyledLogo } from './BoxLogoAvatarStyle';
// import OverWriteMyApps from './styleAppsHeader';
import MyApps from '../../core/MyApps';
import { StyledLinkMobileMenu } from './style';

const MenuList = ({
  show,
  showMobileMenuCategory,
  onToggleMenuBurguer,
  onToggleMobileMenuCategory,
  onClickOutside,
  onChangeSearch,
  value,
  onFocus,
  onToggleSearch,
  name,
  onClickActiveApps
}) => {
  const [menu, setMenu] = useState([]);
  useEffect(() => {
    getHeaderMenu().then(d => {
      setMenu(d);
    });
  }, []);

  return (
    <StyledMenu id="showMenuBurguer" show={show}>
      <StyledBoxNav show={show}>
        <StyledElementsRedesign show={show}>
          <StyledSearchRedesign show={show}>
            <StyledLinkMobileMenu to="/" show={show ? 1 : undefined}>
              <StyledBoxLogo show mobile>
                <StyledLogo
                  svg={Logo}
                  width="70"
                  height="70"
                  resize="241"
                  className="Header-logo"
                />
              </StyledBoxLogo>
            </StyledLinkMobileMenu>
            <SearchHeaderTop
              onChangeSearch={onChangeSearch}
              value={value}
              onFocus={onFocus}
              onToggleSearch={onToggleSearch}
              name={name}
            />
          </StyledSearchRedesign>
          <StyledAccessRedesign show>
            <MyApps
              show
              onClickOutside={onClickActiveApps}
              onClickBack={() => onClickActiveApps}
            />
          </StyledAccessRedesign>

          {menu && menu.length > 0 && (
            <StyledMenuRedesign show>
              {menu.map(({ items, name, id, url }) => (
                <StyledListNav key={id} item={name}>
                  <StyledListTitle
                    onClick={() => onToggleMobileMenuCategory(id)}
                    open={id === showMobileMenuCategory}
                    show
                  >
                    {!url ? (
                      <>
                        {name}
                        <StyledIconDesplegated
                          size="xs"
                          color="light"
                          svg={Arrow}
                        />
                      </>
                    ) : (
                      <StyledListLink href={url} target="_blank">
                        {name}
                      </StyledListLink>
                    )}
                  </StyledListTitle>
                  <StyledBoxList>
                    {items.map(({ page, title, url, target }) =>
                      url && target === 0 ? (
                        <StyledList key={page}>
                          <StyledListDiv onClick={() => onClickOutside(url)}>
                            {title}
                          </StyledListDiv>
                        </StyledList>
                      ) : (
                        <StyledList key={page}>
                          <StyledListLink href={url} target="_blank">
                            {title}
                          </StyledListLink>
                        </StyledList>
                      )
                    )}
                  </StyledBoxList>
                </StyledListNav>
              ))}
            </StyledMenuRedesign>
          )}
        </StyledElementsRedesign>
        <StyledIconClose
          id="closeMenuBurguer"
          svg={Close}
          onClick={onToggleMenuBurguer}
          show
        />
      </StyledBoxNav>
    </StyledMenu>
  );
};

MenuList.propTypes = {
  onToggleMenuBurguer: PropTypes.func,
  show: PropTypes.bool,
  onToggleMobileMenuCategory: PropTypes.func,
  showMobileMenuCategory: PropTypes.number
};

export default withOutsideClick(MenuList);
